/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OnboardingVerify/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import HandPointEasy from 'DesignSystem/Images/HandPointEasy/index'
import OnboardingPhone from 'DesignSystem/Images/OnboardingPhone/index'
import OnboardingUnderline from 'DesignSystem/Images/OnboardingUnderline/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import { animated, useSpring } from "@react-spring/web"



/** @type {import('Simple/types.js').View} */
export default function OnboardingVerify({
  children,
  viewPath = "/App/Auth/SignUpConfirm/Content/OnboardingVerify"
  
}) {
  let isBefore = useIsBefore()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let animatedVertical11 = useSpring({
"config": {
friction: 15,
tension: 300,
},
"delay": 500,
"from": {"left": "-80px","rotate": "40deg"},
"to": {"left": isBefore ? "100px" : "-80px","rotate": isBefore ? "50deg" : "40deg"},
})
  return (<React.Fragment
>
<div
  data-testid="OnboardingVerify.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-mNzuE': isBefore ? 0 : 1,'--tx-2-mNzuE': isBefore ? "50%" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="OnboardingVerify.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<animated.div
  data-testid="OnboardingVerify.Vertical:1"
  data-view-path={viewPath}
 style={{"--l-3-mNzuE": animatedVertical11.left, "--r-4-mNzuE": animatedVertical11.rotate,'--o-1-mNzuE': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical1}`}
>
<HandPointEasy
  viewPath={`${viewPath}/HandPointEasy`}
 width={400}
 height="auto"
/>
</animated.div>
<div
  data-testid="OnboardingVerify.Vertical:2"
  data-view-path={viewPath}
 style={{'--o-1-mNzuE': isBefore ? 0 : 1,'--l-3-mNzuE': isBefore ? "40%" : "25%"}}
 className={`views-block ${styles.Vertical2}`}
>
<OnboardingPhone
  viewPath={`${viewPath}/OnboardingPhone`}
 width={300}
 height="auto"
/>
</div>
<div
  data-testid="OnboardingVerify.Vertical:3"
  data-view-path={viewPath}
 style={{'--bc-6-mNzuE': dtColorsWhite,'--bblr-7-mNzuE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-8-mNzuE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-9-mNzuE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btrr-10-mNzuE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-11-mNzuE': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-12-mNzuE': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-13-mNzuE': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-14-mNzuE': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--o-1-mNzuE': isBefore ? 0 : 1,'--t-5-mNzuE': isBefore ? "45%" : "50%"}}
 className={`views-block ${styles.Vertical3}`}
>
<div
  data-testid="OnboardingVerify.Vertical:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical4}`}
>
<OnboardingUnderline
  viewPath={`${viewPath}/OnboardingUnderline`}
 width={80}
 height={15}
/>
</div>
<div
  data-testid="OnboardingVerify.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="NEW MESSAGE"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Now"
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={12}
 text="Your Practice Hub verification code is: 123456"
 lineHeight={1.3}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}